import Image from "next/image"
import Link from "next/link"
import { ClassValue } from "clsx"

import { baseUrl } from "@/lib/link-utils/link-utils"
import { cn } from "@/lib/utils"
import ImageWithFallback from "@/components/storyblok/common/ImageWithFallback"
import StoryblokAssetClient from "@/components/storyblok/common/StoryblokAssetClient"
import { AssetStoryblok } from "@/components/storyblok/component-types"

export default function HeaderLogo(props: {
  logo: AssetStoryblok | undefined
  subtext: AssetStoryblok | undefined
  sbLocale: string
  className?: string | ClassValue
  oci?: boolean
}) {
  return (
    <div className={cn("flex aspect-[427/78] w-36 shrink-0 grow-0  lg:aspect-[256/70] lg:w-64", props.className)}>
      <Link
        prefetch={false}
        className={"inline-flex flex-col"}
        rel="home"
        href={baseUrl(true, props.sbLocale)}
        aria-label={"Start"}
      >
        {/* TODO load oci image and only show with image */}
        {props.oci /* && oci_image */ ? (
          <ImageWithFallback
            src={/* oci_image.src */ "/img/oci-test-logo.png"}
            alt={/* oci_image.alt */ "logo"}
            className={"size-fit max-h-7 max-w-36 object-contain object-left-bottom lg:max-h-[70px] lg:max-w-64"}
            loading={"eager"}
            width={/* oci_image.width */ 256}
            height={/* oci_image.height */ 70}
            unoptimized={true}
          />
        ) : (
          <>
            <StoryblokAssetClient
              asset={props.logo}
              className={"aspect-[427/78] object-contain"}
              loading="eager"
              width={427}
              height={78}
            />

            <StoryblokAssetClient
              asset={props.subtext}
              className="mt-2 aspect-[412/24] object-contain pr-1.5 max-lg:hidden"
              width={412}
              height={24}
            />
          </>
        )}
      </Link>
    </div>
  )
}
